export const addScriptIfNeeded = (
  url: string,
  errorCallback?: EventListener,
  loadCallback?: EventListener,
): void => {
  let script = document.querySelector(
    `[src="${url}"]`,
  ) as HTMLScriptElement | null;
  if (!script) {
    script = document.createElement("script");
    script.src = url;
    document.body.append(script);
  }

  if (errorCallback) {
    script.addEventListener("error", errorCallback);
  }

  if (loadCallback) {
    script.addEventListener("load", loadCallback);
  }
};
